import { mapModuleRelation } from '@/lib/modules'
import { moduleRepository } from '@/lib/repositories/module.repository'
import type { AppModule } from '@/types/models/module'

export async function fetchTenantModulesService(tenantId: number): Promise<AppModule[]> {
  const relations = await moduleRepository.fetchByTenant(tenantId)
  return relations
    .map(mapModuleRelation)
    .filter((module): module is AppModule => module !== null)
    .sort((a, b) => (a.sort ?? Number.MAX_SAFE_INTEGER) - (b.sort ?? Number.MAX_SAFE_INTEGER))
}
